<template>
  <div style="position: relative;">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <base-info />
      </el-tab-pane>
       <el-tab-pane label="实时数据（列表）" name="dataTable">
    <STable
     v-if="tabName==='dataTable'"
      ref="tableref"
      :url="url"
      :columns="columns"
      :selection="false"
    />
      </el-tab-pane>
      <el-tab-pane label="实时数据（图表）" name="dataEcharts">
        <div class="orderBox">
          <div class="title">
            <div class="word">需求/输出电压</div>
              <el-checkbox-group v-model="checkList" class="checkGroup" @change="handleCheckAllChange">
    <el-checkbox label="需求电压"></el-checkbox>
    <el-checkbox label="实际输出电压"></el-checkbox>
  </el-checkbox-group>
            </div>
          <div id="echartsContent1" class="content"></div>
        </div>
        <div class="orderBox">
          <div class="title">
              <div class="word">需求/输出电流</div>
              <el-checkbox-group v-model="checkList2" class="checkGroup" @change="handleCheckAllChange2">
    <el-checkbox label="需求电流"></el-checkbox>
    <el-checkbox label="实际输出电流"></el-checkbox>
  </el-checkbox-group>
          </div>
          <div id="echartsContent2" class="content"></div>
        </div>
        <div class="orderBox">
          <div class="title">            
            <div class="word">枪线温度</div>
            </div>
          <div id="echartsContent3" class="content"></div>
        </div> 
        </el-tab-pane>
    </el-tabs>
    <el-button type="primary" plain style="position: absolute;right:30px;top:5px;" @click="cancel()">返回</el-button>
  </div>
</template>

<script>
import baseInfo from './components/base-info.vue'
import realTimeList from './components/real-time-list.vue'
import realTimeChart from './components/real-time-chart.vue'
export default {
  name: 'Shishidingdanxiangqing',
  components: {
    baseInfo: baseInfo,
    realTimeList: realTimeList,
    realTimeChart: realTimeChart
  },
    watch:{
   tableData:{
    handler(newval){
    if(newval.length>0){
      // clearInterval(this.timer)
      // this.timer=null
            this.data5=[]
      this.data8=[]
      let a=[]
      a=JSON.parse(JSON.stringify(newval)).reverse()
      a.forEach(item=>{
        this.data5.push(item.枪线温度)
        this.data8.push(item.timeStr)
      })
      if(this.tabName=='dataEcharts'){
      this.loadEachrts3()
      }
    //  this.data5=a
    }
    },
    deep:true
   },
     tableData2:{
    handler(newval){
    if(newval.length>0){
      let a=[]
      a=JSON.parse(JSON.stringify(newval)).reverse()
            this.data1=[]
      this.data2=[]
      this.data3=[]
      this.data4=[]
      this.data6=[]
      this.data7=[]
      a.forEach(item=>{
        this.data1.push(item.BMS电压需求)
        this.data2.push(item.电桩电压输出值)
                this.data3.push(item.BMS电流需求)
        this.data4.push(item.电桩电流输出值)
        this.data6.push(item.timeStr)
        this.data7.push(item.timeStr)
      })
      this.tempData1=this.data1
      this.tempData2=this.data2
      this.tempData3=this.data3
      this.tempData4=this.data4
      if(this.tabName=='dataEcharts'){
      this.loadEachrts()
      this.loadEachrts2()
      }
    }
    },
    deep:true
   }
  },
  data() {
    return {
            url: `/logs/logs/page?orderNo=0000000000000000000000000000000&msgType=19`,
      tabName: 'first',
      delay: 15000,
      tableData:[],
      tableData2:[],
      timer:'',
      orderNum: '', // 当前订单的订单号
      chargeNum: '',
       checkList:['需求电压', '实际输出电压'],
      checkList2:['需求电流','实际输出电流'],
      data1:[],
      tempData1:[],
      tempData2:[],
      tempData3:[],
      tempData4:[],
      data2:[],
      data3:[],
      data4:[],
      data5:[],
      data6:[],
      data7:[],
      data8:[],
            columns: [
        {
          label: "上送时间",
          prop: "timeStr"
        },
        {
          label: "充电电量（度）",
          prop: "充电度数"
        },
        {
          label: "充电时长（分钟）",
          prop: "累计充电时间"
        },
        {
          label: "SOC",
          prop: "SOC"
        },
        {
          label: "已充金额（元）",
          prop: "已充金额",
          // template: (index, reocrd) => {
          //   return this.getFloat(reocrd.totalPower);
          // }
        },
        {
          label: "电压（V）",
          prop: "输出电压",
          // template: (index, reocrd) => {
          //   return reocrd.SOC ? parseFloat(reocrd.SOC) + "%" : "--";
          // }
        },
        {
          label: "电流（A）",
          prop: "输出电流"
        },
        {
          label: "枪线温度（℃）",
          prop: "枪线温度",
          width: "150px"
        },
        {
          label: "电池温度（℃）",
          prop: "电池组最高温度"
        },
      ],
    }
  },
  mounted() {
    // this.getDataDetail()
    this.orderNum = this.$route.query.id
    this.chargeNum = this.$route.query.num
  },
  beforeMount() {
     this.id = this.$route.query.id
    this.url=`/logs/logs/page?orderNo=${this.$route.query.num}&msgType=19`
    // this.id = this.$route.query.data
  },
  methods: {
        handleCheckAllChange(e){
      if(e.length===2){
         this.data1= this.tempData1
        this.data2=this.tempData2
        this.loadEachrts()
      }
      else{
        if(JSON.stringify(e)==JSON.stringify(['需求电压'])){
                this.data1= this.tempData1
                this.data2=[]
                  this.loadEachrts()
        }
             if(JSON.stringify(e)==JSON.stringify(['实际输出电压'])){
                this.data1= []
              this.data2=this.tempData2
                this.loadEachrts()
        }
      }
      if(e.length==0){
          this.data1= []
              this.data2=[]
              this.loadEachrts()
      }
    },
        handleCheckAllChange2(e){
      if(e.length===2){
         this.data3= this.tempData3
        this.data4=this.tempData4
        this.loadEachrts2()
      }
      else{
        if(JSON.stringify(e)==JSON.stringify(['需求电流'])){
                this.data3= this.tempData3
                this.data4=[]
                  this.loadEachrts2()
        }
             if(JSON.stringify(e)==JSON.stringify(['实际输出电流'])){
                this.data3= []
              this.data4=this.tempData4
                this.loadEachrts2()
        }
      }
            if(e.length===0){
          this.data3= []
              this.data4=[]
                this.loadEachrts2()
      }
    },
      handleClick(tab, event) {
        if(tab.name==='dataEcharts'){
                                  const data2 = {
           orderNo: this.$route.query.num,
        msgType: '19',
        pageNo:1,
        pageSize:10,
        loading:true
      }
        this.$store.dispatch('form/handle', {
        url: '/logs/logs/page',
        data: data2,
        method: 'get',
        callback: (resp) => {
          this.tableData=resp.list
}
      })
                 const data = {
           orderNo: this.$route.query.num,
        msgType: '35',
      }
        this.$store.dispatch('form/handle', {
        url: '/logs/logs/page',
        data: data,
        method: 'get',
        callback: (resp) => {
          this.tableData2=resp.list
}
      })
          this.$nextTick(()=>{
          this.loadEachrts()
          this.loadEachrts2()
          this.loadEachrts3()
          })
          // setTimeout(()=>{
          // },1000)
        }
      },
    loadEachrts() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent1")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["需求电压", "实际电压"],
          right:'3%',
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "15%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#FF0000','#1890FF'],
        xAxis: {
          type: "category",
          data: this.data6,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "需求电压",
            type: "line",
            data:this.data1,
            // color:'#FF0000'
          },
          {
            name: "实际电压",
            type: "line",
            data: this.data2,
            // color:"#1890FF;"
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
      loadEachrts2() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent2")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["需求电流", "实际电流"],
             right:'3%',
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "15%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#FF0000','#1890FF'],
        xAxis: {
          type: "category",
          data: this.data7,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "需求电流",
            type: "line",
            data:this.data3,
            // color:'#FF0000'
          },
          {
            name: "实际电流",
            type: "line",
            data: this.data4,
            // color:"#1890FF;"
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
          loadEachrts3() {
      // console.log(1111)
      let chartDom= document.getElementById("echartsContent3")
      if(chartDom){
       let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          show:false,
          data: ["枪线温度"],
          right:0,
          orient: 'vertical',
          itemWidth:40,
          itemHeight:1  ,
          itemGap:35,
          top:80,
          icon:'rect',
          textStyle:{
            fontSize:16
          }
        },
        grid: {
          left: "3%",
          right: "5%",
          top:'10%',
          bottom: "5%",
          containLabel: true
        },
        color:['#1890FF'],
        xAxis: {
          type: "category",
          data: this.data8,
          axisTick: { show: false },
          axisLabel: {
              // interval: 0, // 横向信息全部显示
              show: true,
              // textStyle: {
              //   color: "rgba(255,255,255,.6)",
              //   fontSize: "12"
              // },
              rotate: 30// -30度角倾斜显示
            }
        },
        yAxis: {
          type: "value",
          axisTick: { show: false }
        },
        series: [
          {
            name: "枪线温度",
            type: "line",
            data:this.data5,
            // color:'#FF0000'
          },
        ]
      };
      myChart.setOption(option)
            window.addEventListener("resize", function() {
        myChart.resize();
      });
      
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  },
    destroyed(){
    if(this.timer){
      clearInterval(this.timer)
      this.timer=null
    }
  },
}
</script>

<style lang="less" scoped>
.orderBox {
  height: 306px;
  border: 1px solid rgba(121, 121, 121, 1);
  margin-bottom: 20px;
  .title {
    border-bottom: 3px solid #e1e1e1;
    padding-left: 50px;
    padding-right: 50px;
    display: flex;
    justify-content: space-between;
    .word{
    height: 42px;
    line-height: 42px;
        font-size: 18px;
    font-weight: 700;
    color: #333;
    }
    .checkGroup{
      line-height: 42px;
    }
  }
  .content{
    height: 264px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/orderDetail.vue